var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"value":true,"max-width":"500"},on:{"input":function($event){return _vm.$router.go(-1)}}},[_c('ProductDialogForm',{on:{"change":function($event){return _vm.refresh()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }